module.exports = __webpack_public_path__ + "static/media/wolf_gold.pragmaticplay.4695d7f4.jpeg";